//#region imports
import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DetailsService } from 'src/app/services/details.service';
import { AppConstants } from 'src/app/app.constants';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Globals } from 'src/app/services/globals';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { ContactDetails } from 'src/app/shared/model/save.model';
import { SaveService } from 'src/app/services/save.service';
import { SectionService } from 'src/app/services/section.service';
//#endregion

@Component({
  selector: 'app-details-question12',
  templateUrl: './details-question12.component.html',
  styleUrls: ['./details-question12.component.css']
})
export class DetailsQuestion12Component implements OnInit {
  //#region variables
  contactDetails: ContactDetails;
  firstName: string;
  name: string;
  email: string;
  phone: string;
  street: string;
  streetno:string;
  boxno: string;
  postcode: string;
  choices = [];
  questions = [];
  assuranceCheck = false;
  assuranceError = false;
  firstNameRequired = false;
  lastNameRequired = false;
  firstNameMinlen = false;
  lastNameMinlen = false;
  emailRequired = false;
  emailInvalid = false;
  phoneNumberRequired = false;
  phoneNumberInvalid = false;
  firstNameEntered = false;
  lastNameEntered = false;
  emailIdEntered = false;
  phoneNumberEntered = false;
  clientIdOrSimulationTokenPresent = false;
  //#endregion

  //#region methods
  constructor(
    private detailsService: DetailsService, private globals: Globals, private saveService: SaveService,
    private notification: NotificationService, private guaranteeService: GuaranteeService,
    private translate: TranslateService, private characteristicService: CharacteristicService,
    private sectionService: SectionService) {
    this.characteristicService.setShowPrevious(true);
  }

  ngOnInit() {
    this.sectionService.setCurrentPage('P22-6');
    this.globals.trackPageActivity += ';' + 'P22-6';
    this.clientIdOrSimulationTokenPresent = this.characteristicService.getClientIdOrSimulationTokenPresent();
    this.contactDetails = this.saveService.getContactDetails();
    this.guaranteeService.setGuaranteeComponent(null);
    const sectionKey = AppConstants.SectionConstants.Section2Point2;
    this.questions = this.detailsService.getDetailsQuestion(sectionKey, 'G17');
    const questionChoices = this.detailsService.getDetailsData(sectionKey, 'G17');
    this.setAnswers();
    if (this.contactDetails !== undefined && this.contactDetails !== null) {
      this.firstName = this.firstName === '' ? this.contactDetails.FirstName : this.firstName;
      this.name = this.name === '' ? this.contactDetails.LastName : this.name;
      this.email = this.email === '' ? this.contactDetails.EmailAddress : this.email;
      this.phone = this.phone === '' ? this.contactDetails.Telephone : this.phone;
      this.street = this.contactDetails.StreetName;
      this.streetno = this.contactDetails.StreetNumber;
      this.boxno = this.contactDetails.BoxNumber;
      this.postcode = this.contactDetails.PostalCode;

      this.modelChanged('Apartment_Simulation_User_Name_Question', this.firstName);
      this.modelChanged('Apartment_Simulation_User_Last_Name_Question', this.name);
      this.modelChanged('Apartment_Simulation_Mail_Contact_Question', this.email);
      this.modelChanged('Apartment_Simulation_phone_Contact_Question', this.phone);
      // this.mapAnswer('Apartment_Simulation_User_Name_Question', this.firstName);
      // this.mapAnswer('Apartment_Simulation_User_Last_Name_Question', this.name);
      // this.mapAnswer('Apartment_Simulation_Mail_Contact_Question', this.email);
      // this.mapAnswer('Apartment_Simulation_phone_Contact_Question', this.phone);
    }
    this.globals.quesWarning = false;
    for (const choice in questionChoices) {
      this.choices.push(questionChoices[choice]);
    }
    this.enableOrDisableDetailsNext();
    this.detailsService.getvalidateDetailsNext().subscribe((value) => {
      if(value)
      {
        this.requiredValidatorChk('Apartment_Simulation_User_Name_Question',this.firstName);
        this.requiredValidatorChk('Apartment_Simulation_User_Last_Name_Question',this.name);
        this.requiredValidatorChk('Apartment_Simulation_Mail_Contact_Question',this.email);
        this.requiredValidatorChk('Apartment_Simulation_phone_Contact_Question',this.phone);
        this.requiredValidatorChk('Apartment_Simulation_Optin_Check_Text',this.assuranceCheck);
      }
    });
  }

  setAnswers() {
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    this.globals.quesWarning = false;
    const firstAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G17').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Name_Question').Answers;
    this.firstName = firstAnswer != null ? firstAnswer[0].AnswerText : '';
    const secondAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G17').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Last_Name_Question').Answers;
    this.name = secondAnswer != null ? secondAnswer[0].AnswerText : '';
    const thirdAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G17').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Mail_Contact_Question').Answers;
    this.email = thirdAnswer != null ? thirdAnswer[0].AnswerText : '';
    const fourthAnswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G17').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_phone_Contact_Question').Answers;
    this.phone = fourthAnswer != null ? fourthAnswer[0].AnswerText : '';
    const assuranceAanswer = data.Sections.find(obj => obj.SectionKey === 'S2.2').
      QuestionGroup.find(obj => obj.GroupKey === 'G17').
      Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Optin_Check_Text').Answers;
    if (assuranceAanswer != null && assuranceAanswer.length != null
      && assuranceAanswer.length > 0) {
      this.assuranceCheck =
        assuranceAanswer.findIndex(obj => obj.Answerkey === 'Apartment_Simulation_Optin_Check_Text') >= 0 ? true : false;
    }
  }

  isNumber(evt, code) {
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    if (code === 0) {
      evt = (evt) ? evt : window.event;
      evt.preventDefault();
    } else {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((code.length > 14) || (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode != 43))) {
        evt.preventDefault();
      } else if (charCode === 107) {
        return true;
      } else {
        return true;
      }
    }
  }

  modelChanged(choice, enteredValue) {
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    this.guaranteeService.setInitialPricingData(null);
    if (choice === 'Apartment_Simulation_User_Name_Question') {
      if (enteredValue !== '') {
        this.firstNameRequired = false;
        this.mapAnswer(choice, enteredValue);
      } else {
        this.firstNameRequired = true;
        this.mapAnswer(choice, null);
      }
    } else if (choice === 'Apartment_Simulation_User_Last_Name_Question') {
      if (enteredValue !== '') {
        this.lastNameRequired = false;
        this.mapAnswer(choice, enteredValue);
      } else {
        this.lastNameRequired = true;
        this.mapAnswer(choice, null);
      }
    } else if (choice === 'Apartment_Simulation_Mail_Contact_Question') {
      if (enteredValue !== '') {
        this.emailRequired = false;
        this.emailInvalid = !this.sectionService.validateEmailId(enteredValue);
        (!this.emailInvalid) ? this.mapAnswer(choice, enteredValue) : this.mapAnswer(choice, null);
      } else {
        this.emailRequired = true;
        this.emailInvalid = false;
        this.mapAnswer(choice, null);
      }
    } else if (choice === 'Apartment_Simulation_phone_Contact_Question') {
      if (enteredValue !== '') {
        this.phoneNumberRequired = false;
        this.phoneNumberInvalid = !this.sectionService.validatePhoneNumber(enteredValue);
        (!this.phoneNumberInvalid) ? this.mapAnswer(choice, enteredValue) : this.mapAnswer(choice, null);
      } else {
        this.phoneNumberRequired = true;
        this.phoneNumberInvalid = false;
        this.mapAnswer(choice, null);
      }
    }
    this.enableOrDisableDetailsNext();
  }

  onChange(choice, $event) {
    this.guaranteeService.setInitialPricingData(null);
    this.detailsService.setDetailsProgressBarDetails();
    if(this.globals.isMobile)
    {this.detailsService.setmobileDetailsProgressBarDetails();}
    if ($event.target.checked) {
      this.assuranceCheck = true;
      this.assuranceError = false;
      this.mapAnswer(choice, 'true');
    } else {
      this.assuranceCheck = false;
      this.assuranceError = true;
      this.mapAnswer(choice, 'false');
    }
    this.enableOrDisableDetailsNext();
  }

  mapAnswer(selectedChoice, selectedText) {
    const jsonData = sessionStorage.getItem('jsonData');
    const data = JSON.parse(jsonData);
    let AnswerObject = {};
    let selectedQuestion: any;
    const today = new Date();
    switch (selectedChoice) {
      case 'Apartment_Simulation_User_Name_Question':
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Name_Question');
        AnswerObject = !!selectedText ? {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        } : null;

        data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Name_Question').Answers =
          AnswerObject !== null ? [AnswerObject] : null;
        (AnswerObject !== null) ? this.firstNameEntered = true : this.firstNameEntered = false;
        break;
      case 'Apartment_Simulation_User_Last_Name_Question':
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Last_Name_Question');
        AnswerObject = !!selectedText ? {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        } : null;
        data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_User_Last_Name_Question').Answers =
          AnswerObject !== null ? [AnswerObject] : null;
        (AnswerObject !== null) ? this.lastNameEntered = true : this.lastNameEntered = false;
        break;
      case 'Apartment_Simulation_Mail_Contact_Question':
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Mail_Contact_Question');
        AnswerObject = !!selectedText ? {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        } : null;
        data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Mail_Contact_Question').Answers =
          AnswerObject !== null ? [AnswerObject] : null;
        (AnswerObject !== null) ? this.emailIdEntered = true : this.emailIdEntered = false;
        break;
      case 'Apartment_Simulation_phone_Contact_Question':
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_phone_Contact_Question');
        AnswerObject = !!selectedText ? {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey, AnswerText: selectedText,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        } : null;
        data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_phone_Contact_Question').Answers =
          AnswerObject !== null ? [AnswerObject] : null;
        (AnswerObject !== null) ? this.phoneNumberEntered = true : this.phoneNumberEntered = false;
        break;
      case 'Apartment_Simulation_Optin_Check_Text':
        const translatedChoice = 'Yes'; // this.translate.instant('Apartment_Simulation_Optin_Check_Text');
        selectedQuestion = this.questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Optin_Check_Text');
        const selectedAnswer = {
          ChoiceId: selectedQuestion.QuestionId, Answerkey: selectedQuestion.QuestionKey,
          AnswerText: translatedChoice,
          AnsweredDateTime: formatDate(today, 'dd-MM-yyyy hh:mm:ss', 'en-US', '+0530')
        };
        const answers = data.Sections.find(obj => obj.SectionKey === 'S2.2').
          QuestionGroup.find(obj => obj.GroupKey === 'G17').
          Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Optin_Check_Text').
          Answers;
        if (selectedText === 'true') {
          if (answers == null) {
            data.Sections.find(obj => obj.SectionKey === 'S2.2').
              QuestionGroup.find(obj => obj.GroupKey === 'G17').
              Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Optin_Check_Text').Answers = [selectedAnswer];
          } else if (answers.findIndex(obj => obj.ChoiceId === selectedAnswer.ChoiceId) < 0) {
            data.Sections.find(obj => obj.SectionKey === 'S2.2').
              QuestionGroup.find(obj => obj.GroupKey === 'G17').
              Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Optin_Check_Text').Answers.push(selectedAnswer);
          } else {
            data.Sections.find(obj => obj.SectionKey === 'S2.2').
              QuestionGroup.find(obj => obj.GroupKey === 'G17').
              Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Optin_Check_Text').
              Answers.splice(answers.findIndex(obj => obj.ChoiceId === selectedAnswer.ChoiceId), 1);
          }
        } else {
          data.Sections.find(obj => obj.SectionKey === 'S2.2').
              QuestionGroup.find(obj => obj.GroupKey === 'G17').
              Questions.find(obj => obj.QuestionKey === 'Apartment_Simulation_Optin_Check_Text').
              Answers.splice(answers.findIndex(obj => obj.ChoiceId === selectedAnswer.ChoiceId), 1);
        }
        break;
    }
    this.setContactDetails();
    sessionStorage.setItem('jsonData', JSON.stringify(data));
  }

  setContactDetails() {
    if (this.contactDetails !== undefined && this.contactDetails !== null) {
      this.contactDetails.FirstName = this.firstName;
      this.contactDetails.Name = this.name;
      this.contactDetails.LastName = this.name;
      this.contactDetails.EmailAddress = this.email;
      this.contactDetails.Telephone = this.phone;
      this.contactDetails.StreetName = this.street;
      this.contactDetails.StreetNumber = this.streetno;
      this.contactDetails.BoxNumber = this.boxno;
      this.contactDetails.PostalCode = this.postcode;
      this.saveService.setContactDetails(this.contactDetails);
    } else {
      const contactDetails: ContactDetails = {
        FirstName: this.firstName, LastName: this.name, EmailAddress: this.email,
        PostalCode: '', Telephone: this.phone, Name: '', DateofBirth: '', StreetName : '',
        StreetNumber: '', BoxNumber: ''
      };
      this.saveService.setContactDetails(contactDetails);
    }
  }

  requiredValidatorChk(selectedChoice, value) {
    switch (selectedChoice) {
      case 'Apartment_Simulation_User_Name_Question':
        (value === '') ? this.firstNameRequired = true : this.firstNameRequired = false;
        (value.length < 2 && value.length > 0) ? this.firstNameMinlen = true: this.firstNameMinlen = false;
        break;
      case 'Apartment_Simulation_User_Last_Name_Question':
        (value === '') ? this.lastNameRequired = true : this.lastNameRequired = false;
        (value.length < 2 && value.length > 0) ? this.lastNameMinlen = true : this.lastNameMinlen = false;
        break;
      case 'Apartment_Simulation_Mail_Contact_Question':
        (value === '') ? this.emailRequired = true : this.emailRequired = false;
        break;
      case 'Apartment_Simulation_phone_Contact_Question':
        (value === '') ? this.phoneNumberRequired = true : this.phoneNumberRequired = false;
        break;
        case 'Apartment_Simulation_Optin_Check_Text':
          (value === false)? this.assuranceError = true: this.assuranceError = false;
    }
  }

  enableOrDisableDetailsNext() {
    if (this.firstNameEntered && this.lastNameEntered && this.emailIdEntered && this.phoneNumberEntered && this.assuranceCheck) {
      this.detailsService.setDisableDetailsNext(false);
    } else {
      this.detailsService.setDisableDetailsNext(false);
    }
  }

  helpDialog(value: string) {
    value = this.translate.instant(value);
    this.notification.openDialog(value);
  }
  //#endregion
}
